import React, { Component } from 'react';
import { defaultAppTitle } from '../config/functions'
import { Helmet } from 'react-helmet';
import { Hero } from '../components';
import { Link } from 'react-router-dom';

import LinkedInIcon from '../assets/icons/linkedin.svg'
import InstagramIcon from '../assets/icons/instagram.svg'
import TwitterIcon from '../assets/icons/twitter.svg'

class Contact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTitle: 0,
            titles: [
                'Say hello 👋',
                'Say hello 🖐️'
            ],
            metaDescription: 'Do you have a web project you\'d like to discuss? Get in touch via email or contact me via LinkedIn and Twitter'
        }

        this.interval
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            const { activeTitle, titles } = this.state

            let nextTitle = activeTitle + 1;
            if (activeTitle >= (titles.length - 1)) {
                nextTitle = 0
            }

            this.setState({
                activeTitle: nextTitle
            })
        }, 500)
    }

    componentWillUnmount() {
        clearInterval( this.interval )
    }

    render() {
        const { activeTitle, titles } = this.state

        return (
            <div key="Contact">
                <Helmet>
                    <title>{`${titles[activeTitle]} // ${defaultAppTitle}`}</title>
                    <meta name="description" content={this.state.metaDescription} />
                    <meta name="og:description" content={this.state.metaDescription} />
                </Helmet>
                <Hero className="hero hero--narrow">
                    <h1 className="alpha">Say hello</h1>
                    <h2 className="beta">Have you got a project you’d like to discuss? Let’s talk...</h2>
                    <ul>
                        <li className="beta"><a href="mailto:hello@davidwalker.info">hello@davidwalker.info</a></li>
                        <li className="beta"><a href="tel:07702010144">07702 01 01 44</a></li>
                        <li className="beta">
                            <ul className="u-list-inline u-margin--top-double">
                                <li>
                                    <a href="https://www.linkedin.com/in/davidwalker1986/" target="_blank" rel="noopener noreferrer">
                                        <img width="48" height="48" src={LinkedInIcon} alt="LinkedIn" />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/davwalkr" target="_blank" rel="noopener noreferrer">
                                        <img width="48" height="48" src={TwitterIcon} alt="Twitter" />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://instagram.com/davewalker" target="_blank" rel="noopener noreferrer">
                                        <img width="48" height="48" src={InstagramIcon} alt="Instagram" />
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </Hero>
            </div>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact.js